<template>
  <div class="lang" :class="{'open' : isOpen}">
    <div class="selected" @click="toggle">{{selected}}<i class="icon-expand_more" /></div>
    <ul class="dropdown">
      <li class="dropdown-item" v-for="lang in langs" @click="select(lang)" :class="{'active': lang==selected}">{{lang}}</li>
    </ul>
  </div>
</template>

<script>
    import { supportedLanguages, setI18nLanguage } from "@/plugins/i18n.plugin";
    export default {
        name: 'Lang',
        data() {
            return {
                isOpen: false,
                selected: this.$i18n.locale,
                langs: supportedLanguages
            }
        },
        methods: {
            select(lang) {
                this.isOpen = false;
                this.selected = lang;
                setI18nLanguage(lang);

                window.location = window.location;
            },
            toggle() {
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>

<style lang="scss">
</style>
